if(document.querySelector("div.filter-container")) {
    document.querySelector("div.filter-container select[name='quarter']").addEventListener("change", (evt) => {
        document.querySelector("form.filter-form").submit();
    });
    if(document.querySelector("div.filter-container select[name='holder']")) {
        document.querySelector("div.filter-container select[name='holder']").addEventListener("change", (evt) => {
            document.querySelector("form.filter-form").submit();
        });
    }
}